import React from "react"
import Layout from "../../../components/layout"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            GET /activitiesrecord/spaces <b>DEPRECATED</b>
          </h1>
        </div>
        <p>
          Paginated response with an array of spaces (topics) modified{" "}
          <b>after</b> or <b>before</b> the specified reference time.
        </p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>spacetype</td>
                <td>Type of space: 'group' or 'direct'</td>
                <td>Query</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>after</td>
                <td>
                  UTC timestamp (number of milliseconds elapsed since 1 January
                  1970 00:00:00 UTC) after which to return activity.
                </td>
                <td>Query</td>
                <td>Yes (one of after or before)</td>
                <td />
              </tr>
              <tr>
                <td>before</td>
                <td>
                  UTC timestamp (number of milliseconds elapsed since 1 January
                  1970 00:00:00 UTC) before which to return activity.
                </td>
                <td>Query</td>
                <td>Yes (one of after or before)</td>
                <td />
              </tr>
              <tr>
                <td>page</td>
                <td>Page of results, starting from 0, default is 0.</td>
                <td>Query</td>
                <td>No</td>
                <td>0</td>
              </tr>
              <tr>
                <td>size</td>
                <td>Number of results to return per page, default is 30.</td>
                <td>Query</td>
                <td>No</td>
                <td>30</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>Read Topic.</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET https://spacesapis.avayacloud.com/api/activitiesrecord/spaces
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"data": [{"\n"}
          {"      "}
          {"{"}
          {"\n"}
          {"          "}"_id": "59aee14d75b76d59ea37d46d",{"\n"}
          {"          "}"topicId": "5935d96087eed333d5beb05c",{"\n"}
          {"          "}"status": 1,{"  "}///// flag of space archived{"\n"}
          {"          "}"modified": "2017-09-05T20:40:51.710Z",{"\n"}
          {"          "}"users": [{"\n"}
          {"              "}
          {"{"}
          {"\n"}
          {"                  "}"user": "588cc8827b40f9a576054c20", //this is
          user who is queries{"\n"}
          {"                  "}"left": false{"\n"}
          {"              "}
          {"}"}
          {"\n"}
          {"          "}]{"\n"}
          {"      "}
          {"}"},{"\n"}
          {"      "}
          {"{"}
          {"\n"}
          {"          "}"_id": "59af0be975b76d59ea3ed9b2",{"\n"}
          {"          "}"topicId": "59a9bb15a1c4f2b06727dc1c",{"\n"}
          {"          "}"type": "group",{"\n"}
          {"          "}"status": 0,{"\n"}
          {"          "}"modified": "2017-09-05T20:42:11.065Z",{"\n"}
          {"          "}"users": [{"\n"}
          {"              "}
          {"{"}
          {"\n"}
          {"                  "}"user": "588cc8827b40f9a576054c20", // this is
          user who queries{"\n"}
          {"                  "}"left": true // this is flag of user left from
          the space{"\n"}
          {"              "}
          {"}"}
          {"\n"}
          {"          "}]{"\n"}
          {"      "}
          {"}"},{"\n"}
          {"      "}
          {"{"}
          {"\n"}
          {"          "}"_id": "59a9aec84d6a919bde4b48e9",{"\n"}
          {"          "}"title": "new334333",{"\n"}
          {"          "}"description": "",{"\n"}
          {"          "}"status": 0,{"\n"}
          {"          "}"members": [{"\n"}
          {"              "}
          {"{"}
          {"\n"}
          {"                  "}"member": "588cc8827b40f9a576054c20",{"\n"}
          {"                  "}"memberType": "userId",{"\n"}
          {"                  "}"role": "admin",{"\n"}
          {"                  "}"joinTime": "2017-09-01T19:02:32.142Z",{"\n"}
          {"                  "}"username": "patrickhan@esna.com",{"\n"}
          {"                  "}"displayname": "Patrick-123 Han-han",{"\n"}
          {"                  "}"picture_url":
          "pictures/pfpic_patrickhan_ac87aef2-9452-47fc-ae73-e1937acd3730"{"\n"}
          {"              "}
          {"}"}
          {"\n"}
          {"          "}],{"\n"}
          {"          "}"settings": {"{"}
          {"\n"}
          {"              "}"confId": "221312218",{"\n"}
          {"              "}"mdOpts": [],{"\n"}
          {"              "}"mdSrv": "ams"{"\n"}
          {"          "}
          {"}"},{"\n"}
          {"          "}"created": "2017-09-01T19:02:32.149Z",{"\n"}
          {"          "}"type": "group",{"\n"}
          {"          "}"isPinned": null,{"\n"}
          {"          "}"notification": null,{"\n"}
          {"          "}"role": "admin",{"\n"}
          {"          "}"lastAccess": "2017-09-05T20:42:41.043Z"{"\n"}
          {"      "}
          {"}"}
          {"\n"}
          {"  "}],{"\n"}
          {"  "}"nextPageUrl":
          "/api/activitiesrecord/spaces?topictype=&amp;after=1504633006610&amp;size=3&amp;page=1&amp;prev=false",
          {"\n"}
          {"  "}"previousPageUrl": "",{"\n"}
          {"  "}"total": 3{"\n"}
          {"}"}
          {"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
